'use server'

import { categoryType } from '@/lib/category'
import { api_url } from './api/url'

export type subcategoryType = {
  service_id: string
  subcategory_id: number
  name: string
  description: string
  top_image_url: string
  eyecatch_image: string
  hide: boolean
  sort_order: number
  category_id: number
  seo_text: string
  created_at: string
  updated_at: string
}

export type responseSubcategoryType = {
  subcategory: subcategoryType
  category: categoryType
}

export type responseSubcategoriesType = {
  subcategories: subcategoryType[]
}

export const getSubcategories = async (service: string, ids: string = '') => {
  const url = new URL(`${api_url(service)}/subcategory?ids=${ids}`)
  const res = await fetch(url, {
    method: 'GET',
    next: {
      revalidate: process.env.NODE_ENV === 'production' ? 60 * 60 * 10 : 10,
      tags: [`subcategories-${service}`],
    },
  })
  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as responseSubcategoriesType

  return data.subcategories.sort((a, b) => a.sort_order - b.sort_order)
}

export const getSubcategoryByCategoryId = async (
  service: string,
  categoryId: number,
) => {
  const url = new URL(
    `${api_url(service)}/subcategory?category_id=${categoryId}`,
  )
  const res = await fetch(url, {
    method: 'GET',
    next: {
      revalidate: process.env.NODE_ENV === 'production' ? 60 * 60 * 10 : 10,
      tags: [`subcategories-${service}-${categoryId}`],
    },
  })
  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as responseSubcategoriesType

  return data.subcategories
}

export const getSubcategory = async (service: string, id: number) => {
  const url = new URL(`${api_url(service)}/subcategory/${id}`)
  const res = await fetch(url, {
    method: 'GET',
    next: {
      revalidate: process.env.NODE_ENV === 'production' ? 60 * 60 * 10 : 1,
      tags: [`subcategory-${service}-${id}`],
    },
  })
  if (res.status !== 200) {
    return null
  }
  const data = (await res.json()) as responseSubcategoryType

  return data
}

// export const getSubcategory = async (service: string, id: number) => {
//   const cached = unstable_cache(
//     async () => {
//       const url = new URL(`${api_url(service)}/subcategory/${id}`)
//       const res = await fetch(url, {
//         method: 'GET',
//       })
//       if (res.status !== 200) {
//         return null
//       }
//       return (await res.json()) as responseSubcategoryType
//     },
//     [`subcategory-${service}-${id}`],
//     {
//       revalidate: process.env.NODE_ENV === 'production' ? 60 * 60 * 10 : 10,
//       tags: [`subcategory-${service}-${id}`],
//     },
//   )

//   return cached()
// }
